import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import websitelogo from '../../../../assets/logos/websitelogo.svg';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CallIcon from '@mui/icons-material/Call';
import { login } from '../../../services/api/apiManager';
import './login.css';
// import { useSnackbar } from "notistack";
import { useDispatch } from 'react-redux';
import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
} from '../../../services/authService/accountActions';
import { actions } from '../../../services/state/Reducer';
import authService from '../../../services/authService/authService';

import {
	Alert,
	Box,
	Checkbox,
	CssBaseline,
	FormControlLabel,
	Grid,
	IconButton,
	InputAdornment,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import {
	LockOutlined,
	SecurityRounded,
	SupportAgentRounded,
	Visibility,
	VisibilityOff,
} from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';
import { useStateValue } from '../../../services/state/State';
// const { enqueueSnackbar } = useSnackbar();

function Login() {
	const [{ user }, dispatch] = useStateValue();
	const defaultTheme = createTheme();
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [openSnackbarEmpty, setOpenSnackbarEmpty] = useState(false);
	const [openSnackbarError_, setOpenSnackbarError_] = useState(false);
	// const [showIncorrectPasscode, setShowIncorrectPasscode] = useState(false);
	const lcemail = localStorage.getItem('rememail');
	const lcpass = localStorage.getItem('rempass');
	const check = localStorage.remcheck;
	const [email, setEmail] = useState(lcemail || '');
	const [password, setPassword] = useState(lcpass || '');
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleSignupClick = () => {
		// Navigate to the signup page
		navigate('/signup');
	};
	// const handleCheckboxChange = (event) => {
	// 	setShowIncorrectPasscode(false);
	// };

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
		setOpenSnackbarError_(false);
		setOpenSnackbarEmpty(false);
	};
	const onSubmit = async () => {
		setLoading(true);

		try {
			debugger;

			if (!email || !password) {
				setOpenSnackbarEmpty(true);
				return;
			}
			const model = {
				email: email,
				password: password,
			};
			const res = await login(model);
			if (res?.status === 200) {
				const loggedInUser = {
					...res.data,
					userDetail: res.data || null,
					token: res.data.access_token || '',
				};
				//   authService.setUser(loggedInUser);
				authService.setrefreshToken(res?.data?.refresh_token);
				authService.setaccessToken(res?.data?.access_token);
				localStorage.setItem('userName', res?.data?.full_name);
				dispatch({ type: actions.SET_USER, payload: loggedInUser });
				navigate('/selectPractice');
				authService.setSession(res.data.access_token, navigate);
			} else if (
				res?.response?.data?.msg ==
				'Error in LoginUser post: Invalid credentials, Try Again Please'
			) {
				setOpenSnackbarError(true);
			} else {
				setOpenSnackbarError_(true);
			}
		} catch (error) {
			setOpenSnackbarError_(true);
		}
		setLoading(false);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			onSubmit();
		}
	};
	const RememberData = (checked) => {
		debugger;
		if (checked) {
			localStorage.removeItem('rememail');
			localStorage.setItem('rememail', email);
			localStorage.removeItem('rempass');
			localStorage.setItem('rempass', password);
			localStorage.removeItem('remcheck');
			localStorage.setItem('remcheck', checked);
		} else {
			localStorage.removeItem('remcheck');
			localStorage.removeItem('rempass');
			localStorage.removeItem('rememail');
		}
	};
	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				className="login-page"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/Authentication-bg.webp')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '28px 36px',
					'@media (max-width: 600px)': {
						padding: '14px',
					},
				}}
			>
				<CssBaseline />
				<Grid
					container
					item
					justifyContent="center"
					className="login-shell"
					sx={{
						maxWidth: '980px',
						borderRadius: '24px',
						overflow: 'hidden',
						boxShadow: '0 28px 70px rgba(74, 95, 132, 0.22)',
						backgroundColor: 'rgba(255,255,255,0.68)',
						border: '1px solid rgba(255,255,255,0.72)',
						backdropFilter: 'blur(8px)',
					}}
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						className="login-brand-panel"
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
							minHeight: '560px',
							display: { sm: 'none', xs: 'none', md: 'flex' },
						}}
					>
						<Box className="login-brand-logo">
						</Box>
						<Box className="login-brand-copy">
							<Typography
								variant="h3"
								className="slide-in login-brand-title"
							>
								Welcome to MaxCharts
							</Typography>
							<Box className="login-brand-accent" />
							<Typography variant="h6" className="slide-in login-brand-subtitle">
								Connecting Doctors, Patients, and Billing in Harmony
							</Typography>
						</Box>
						<Box className="login-brand-footer">
							<Box className="login-feature-card">
								<Box className="login-feature-icon">
									<SecurityRounded />
								</Box>
								<Box>
									<Typography className="login-feature-title">
										Secure & Reliable
									</Typography>
									<Typography className="login-feature-text">
										Your data is always safe with us.
									</Typography>
								</Box>
							</Box>
							<Box className="login-feature-divider" />
							<Box className="login-feature-card">
								<Box className="login-feature-icon">
									<SupportAgentRounded />
								</Box>
								<Box>
									<Typography className="login-feature-title">
										24/7 Support
									</Typography>
									<Typography className="login-feature-text">
										We are here to help you anytime.
									</Typography>
								</Box>
							</Box>
						</Box>
						<Box className="login-links-row">
							<Box className="login-link-item">
								<ContactSupportIcon className="login-link-icon" />
								<Link to={'/aboutUs'} className="login-side-link">
									<Typography>About Us</Typography>
								</Link>
							</Box>
							<Box className="login-link-item">
								<CallIcon className="login-link-icon" />
								<Link to={'/contactUs'} className="login-side-link">
									<Typography>Contact Us</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
					<Grid
						component={Paper}
						elevation={6}
						square
						item
						xs={12}
						sm={12}
						md={6}
						lg={6}
						xl={6}
						className="login-form-panel"
						sx={{
							background: 'rgba(255,255,255,0.96)',
							padding: { xs: '18px 14px', sm: '20px 18px', md: '20px 24px' },
							'@media (max-width: 600px)': {
								minHeight: 'auto',
							},
						}}
					>
						{loading ? (
							<BrandedLoader
								title="Signing you in"
								text="Preparing your MaxCharts workspace"
								minHeight="420px"
							/>
						) : (
							<Box className="login-form-wrap">
								<Box className="login-form-logo">
									<img
										src={websitelogo}
										alt="MaxCharts"
										style={{
											width: '190px',
											height: 'auto',
											objectFit: 'contain',
										}}
									/>
								</Box>
								<Typography
									component="h1"
									variant="h5"
									className="login-form-title"
								>
									Login
								</Typography>
								<Typography className="login-form-subtitle">
									Please sign in to your account
								</Typography>
								<Box
									component="FORM"
									className="login-form"
								>
									<Typography
										variant="body2"
										className="login-field-label"
									>
										Email Address
									</Typography>
									<OutlinedInput
										className="login-input"
										size="small"
										fullWidth
										type="email"
										name="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										autoComplete="email"
										placeholder="Enter your email address"
										required
										startAdornment={
											<InputAdornment position="start">
												<MailOutlineOutlinedIcon className="login-input-icon" />
											</InputAdornment>
										}
										endAdornment={
											<></>
										}
									/>
									<Typography
										variant="body2"
										className="login-field-label"
									>
										Password
									</Typography>
									<OutlinedInput
										className="login-input"
										size="small"
										fullWidth
										required
										name="password"
										autoComplete="off"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										onKeyDown={(e) => handleKeyDown(e)}
										type={showPassword ? 'text' : 'password'}
										placeholder="Enter your password"
										startAdornment={
											<InputAdornment position="start">
												<LockOutlined className="login-input-icon" />
											</InputAdornment>
										}
										endAdornment={
											<InputAdornment position="end">
												<IconButton
													aria-label="toggle password visibility"
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
													sx={{ color: '#8a95ad' }}
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										}
									/>
									<Grid container className="login-form-row">
										<Grid item xs>
											<FormControlLabel
												className="login-remember"
												control={
													<Checkbox
														sx={{
															color: '#2e73c9',
															'&.Mui-checked': {
																color: '#2e73c9',
															},
														}}
														defaultChecked={check}
														color="primary"
														onChange={(e) => RememberData(e.target.checked)}
													/>
												}
												label="Remember me"
											/>
										</Grid>
										<Grid item>
											<Link to="/forgotpassword" className="login-forgot-link">
												<Typography variant="body2" fontSize={'13px'}>
													Forgot Password?
												</Typography>
											</Link>
										</Grid>
									</Grid>
									<Button
										variant="contained"
										fullWidth
										size="small"
										sx={{
											background: '#e87511',
											borderRadius: '10px',
											height: '44px',
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '600',
											marginTop: '6px',
											marginBottom: '14px',
											boxShadow: '0 12px 22px rgba(232, 117, 17, 0.22)',
											'&:hover': {
												background: '#e87511',
											},
										}}
										disabled={!email || !password}
										onClick={() => onSubmit()}
									>
										Sign In
									</Button>
									<Box className="login-divider-row">
										<Box className="login-divider-line" />
										<Box className="login-divider-badge">or</Box>
										<Box className="login-divider-line" />
									</Box>
									<Box className="login-signup-row">
										<Typography className="login-signup-text">
											Don&apos;t have an account?
										</Typography>
										<Link to={'/signup'} className="login-signup-link">
											<Typography>Sign up</Typography>
										</Link>
									</Box>
								</Box>
							</Box>
						)}
					</Grid>
				</Grid>

				{/* snackbars  */}

				<Snackbar
					open={openSnackbarError}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Invalid Credentials, Please Try again !
					</Alert>
				</Snackbar>
				<Snackbar
					open={openSnackbarEmpty}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Fill in all fields
					</Alert>
				</Snackbar>
				<Snackbar
					open={openSnackbarError_}
					autoHideDuration={3000}
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="error"
						sx={{
							backgroundColor: '#ED2828',
							color: '#FFF',
							fontSize: '15px',
							padding: '15px',
						}}
					>
						Something Went Wrong!
					</Alert>
				</Snackbar>
			</Grid>
		</ThemeProvider>
	);
}

export default Login;
